/**
 * Sidebar / bottom app bar for client dashboard (BooksyAppExpo-style).
 */
import React, { memo, useMemo, useState } from 'react';
import { FaChevronLeft } from 'react-icons/fa';
import ELogo from '../ELogo';

const NavButton = memo(({ item, active, count, onClick }) => {
  const { key, title, icon: IconComponent } = item;
  const isLogout = key === 'logout';
  const [hot, setHot] = useState(false);

  return (
    <button
      className={`nav-btn ${isLogout ? 'logout' : ''} ${active === key ? 'active' : ''} ${hot ? 'is-hot' : ''}`}
      onClick={onClick}
      onPointerEnter={() => setHot(true)}
      onPointerLeave={() => setHot(false)}
      onPointerDown={() => setHot(true)}
      onPointerUp={() => setHot(false)}
      onPointerCancel={() => setHot(false)}
      aria-current={active === key ? 'page' : undefined}
      aria-label={title}
      title={title}
      type="button"
    >
      <span className="nav-icon-container" style={{ position: 'relative' }}>
        <IconComponent className="nav-img" aria-hidden="true" />
        {count > 0 && (
          <span className="nav-badge" aria-label={`${count} unread`}>
            {count > 99 ? '99+' : String(count)}
          </span>
        )}
      </span>
      <span className="nav-title">{title}</span>
    </button>
  );
});

NavButton.displayName = 'NavButton';

const Sidebar = memo(
  ({
    nav,
    active,
    onSelect,
    onLogout,
    badgeCounts = {},
    isOpen,
    onClose,
  }) => {
    const { items, logoutItem } = useMemo(() => {
      const logout = nav.find((item) => item.key === 'logout') || null;
      const items = nav.filter((item) => item.key !== 'logout');
      return { items, logoutItem: logout };
    }, [nav]);

    return (
      <nav
        className={`nav-container nav--client nav--tray ${isOpen ? '' : 'sidebar-closed'}`}
        aria-label="Primary"
      >
        <div className="sidebar-title sidebar-title--tray">
          <div className="sidebar-logo-plate">
            <ELogo size="medium" />
          </div>
        </div>

        <div className="nav-tray">
          <div className="nav-items">
            {items.map((item) => (
              <NavButton
                key={item.key}
                item={item}
                active={active}
                count={badgeCounts[item.key] || 0}
                onClick={() => onSelect(item.key)}
              />
            ))}
          </div>
        </div>

        {logoutItem && (
          <NavButton
            item={logoutItem}
            active={active}
            count={0}
            onClick={onLogout}
          />
        )}

        {isOpen && (
          <button
            className="sidebar-close-btn"
            onClick={onClose}
            aria-label="Close sidebar"
            title="Close sidebar"
            type="button"
          >
            <FaChevronLeft aria-hidden="true" />
          </button>
        )}
      </nav>
    );
  }
);

Sidebar.displayName = 'Sidebar';
export default Sidebar;
